import { useTranslation } from "react-i18next";
import { LockedIcon } from "./locked-content.styled";

export const LockedContent = () => {
    const { t } = useTranslation('private-home-page');
    return (
        <LockedIcon src="/assets/img/lock-icon.svg" title={t('talent.unlockThisCandidate')} />
    );
}